import React, { lazy, Suspense } from 'react';
import Loading from '../common/components/Loading';

const Main = lazy(() => import('../app/main/ui/Main'));
const Category = lazy(() => import('../app/category/ui/Main'));
const Announcement = lazy(() => import('../app/announcement/ui/Main'));
const Sign = lazy(() => import('../app/sign/ui/Main'));
const SmsCode = lazy(() => import('../app/sign/sms/SmsCode'));
const Register = lazy(() => import('../app/sign/in/Register'));
const Profile = lazy(() => import('../app/profile/ui/Main'));
const AdForm = lazy(() => import('../app/adform/ui/Main'));
const AboutUs = lazy(() => import('../app/aboutus/ui/Main'));
const Review = lazy(() => import('../app/review/ui/Review'));
const Promote = lazy(() => import('../app/promote/ui/Main'));
const Company = lazy(() => import('../app/company/ui/Main'));
const Edit = lazy(() => import('../app/edit/ui/Main'));
const Reviews = lazy(() => import('../app/reviews/ui/Main'));
const News = lazy(() => import('../app/news/ui/Main'));
const Adshow = lazy(() => import('../app/adshow/ui/Main'));
const Notifications = lazy(() => import('../app/notifications/ui/Main'));
const NotFound = lazy(() => import('../app/notfound/ui/NotFound.js'));
const OrderCreate = lazy(() => import('../app/order/ui/Main'));
const CartPage = lazy(() => import('../app/cart/ui/Cart'));
const TeamPoolPage = lazy(() => import('../app/teamPool/ui/TeamPool'));

const withSuspense = (Component) => (
    <Suspense fallback={<Loading />}>
        <Component />
    </Suspense>
);

const routes = [
    { path: '/', element: withSuspense(Main) },
    { path: '/category/:category_name/:subcategory_name/:category_id/:subcategory_id', element: withSuspense(Category) },
    { path: '/announcement/:slugOrId', element: withSuspense(Announcement) },
    { path: '/sign', element: withSuspense(Sign) },
    { path: '/sms-code', element: withSuspense(SmsCode) },
    { path: '/register', element: withSuspense(Register) },
    { path: '/profile', element: withSuspense(Profile) },
    { path: '/adform', element: withSuspense(AdForm) },
    { path: '/preview', element: withSuspense(Review) },
    { path: '/aboutus', element: withSuspense(AboutUs) },
    { path: '/promote', element: withSuspense(Promote) },
    { path: '/company', element: withSuspense(Company) },
    { path: '/edit', element: withSuspense(Edit) },
    { path: '/reviews/:id', element: withSuspense(Reviews) },
    { path: '/news/:service/:id', element: withSuspense(News) },
    { path: '/adshow/:id', element: withSuspense(Adshow) },
    { path: '/notifications', element: withSuspense(Notifications) },
    { path: '/order/new', element: withSuspense(OrderCreate) },
    { path: '/order/:id', element: withSuspense(OrderCreate) },
    { path: '/cart', element: withSuspense(CartPage) },
    { path: '/team-pool', element: withSuspense(TeamPoolPage) },
];

export default routes;